import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import CreaDDFWidget from '@components/widget/CreaDDFWidget';

const CREADDF = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fad fa-chevron-right mr-2" />
        CREA
        <span className="fw-300 ml-2 mr-2">DDF®</span>
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-12">
        <Panel>
          <p>
            CREA has created a Data Distribution Facility (DDF®) to enable CREA&apos;s members to easily disseminate MLS® listing content to&nbps;
            multiple websites, and to ensure that MLS® listing content that is displayed on these websites is accurate, up to date, and uses CREA&apos;s trademarks correctly.
          </p>
          <p>
            You can use the DDF® to share your listings with other REALTORS®, with Franchisors, as well as approved real estate advertising websites. You can also receive a feed of listing content from the DDF® for display on your own website.
          </p>
        </Panel>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <CreaDDFWidget />
        </Panel>
      </div>
    </div>
  </>
);

export default CREADDF;
